<!-- Header Structure -->
<template>
	<div>
		<v-navigation-drawer
			v-if="!horizontal"
			app
			fixed
			v-model="drawer"
			:mini-variant.sync="collapseSidebar"
			mini-variant-width="70"
			:width="250"
			class="Vuely-sidebar"
			:style="{ backgroundImage: 'url(' + selectedSidebarBgImage.url + ')' }"
			:class="{ 'background-none': !backgroundImage }"
			:right="rtlLayout"
		>
			<!-- App Sidebar -->
			<app-sidebar></app-sidebar>
		</v-navigation-drawer>
		<v-toolbar
			class="Vuely-toolbar header-toolbar"
			app
			:color="activeHeaderFilter.class"
			fixed
		>
			<div class="d-custom-flex align-items-center navbar-left">
				<div v-if="!horizontal">
					<v-toolbar-side-icon
						icon
						large
						@click.stop="drawer = !drawer"
						class="v-step-0"
					></v-toolbar-side-icon>
				</div>
				<div
					class="site-logo-wrap d-custom-flex ml-0 align-items-center"
					v-else
				>
					<router-link
						to="/horizontal/dashboard/ecommerce"
						class="grayish-blue site-logo-img"
					>
						<img
							src="/static/img/site-logo.png"
							alt="site logo"
							width="100"
							height="30"
						/>
					</router-link>
				</div>
				<v-btn
					outline
					v-if="roleUser === 1"
					@click="sendBroadcast"
					class="white--text"
					color="success"
				>
					<v-icon>zmdi-mail-send</v-icon>
					<span class="mx-2">{{ $t("message.sendBroadcast") }}</span>
				</v-btn>
				<div class="store-icons-container" v-if="roleUser === 2">
					
					<v-btn v-if="stores.telegram" flat small target="_blank" :href="stores.telegram">
						Tienda telegram <v-icon>mdi-telegram</v-icon>
					</v-btn>
					<v-btn v-if="stores.web" flat small  target="_blank" :href="stores.web">
						Tienda web <v-icon>mdi-web</v-icon>
					</v-btn>
				</div>
			</div>

			<div class="navbar-right">
				<!-- <v-btn icon large @click="toggleFullScreen" class="full-screen ma-0">
					<v-icon color="grey">fullscreen</v-icon>
				</v-btn> -->
				<!-- <notifications></notifications> -->
				<!-- <v-btn outline v-if="roleUser === 1" @click="sendBroadcast" class="white--text" color="success">
					<v-icon>zmdi-mail-send</v-icon>
					<span class="mx-2">{{ $t('message.sendBroadcast') }}</span>
				</v-btn> -->
				<user></user>
			</div>
		</v-toolbar>
		<broadcast-message :dialog.sync="showSendMessage" ref="broadcastMessage">
		</broadcast-message>
	</div>
</template>

<script>
import Sidebar from "../Sidebar/Sidebar.vue";
import ChatSidebar from "../ChatSidebar/ChatSidebar.vue";
import screenfull from "screenfull";
import LanguageProvider from "./LanguageProvider";
import Notifications from "./Notifications";
import BroadcastMessage from "../../views/dashboard/BroadcastMessage";
import User from "./User";
import Cart from "./Cart";
import QuickLinks from "./QuickLinks";
import MobileSearchForm from "./MobileSearchForm";
import { getCurrentAppLayout } from "Helpers/helpers";
import { mapGetters } from "vuex";

export default {
	props: {
		horizontal: {
			default: false,
			type: Boolean,
		},
	},
	data() {
		return {
			collapsed: false, // collapse sidebar
			drawer: null, // sidebar drawer default true
			chatSidebar: false, // chat component right sidebar
			sidebarImages: "", // sidebar background images
			enableDefaultSidebar: false,
			showSendMessage: false,
		};
	},
	computed: {
		...mapGetters([
			"rtlLayout",
			"backgroundImage",
			"backgroundImage",
			"selectedSidebarBgImage",
			"darkMode",
			"collapseSidebar",
			"activeHeaderFilter",
		]),
		roleUser() {
			let userData = JSON.parse(localStorage.getItem("userData"));
			return userData.role_id;
		},
		stores() {
			const data = this.$store.getters.store;
			return {
				telegram: `https://t.me/${data.telegram_user_bot}`,
				web: `${process.env.VUE_APP_WEB_STORE_URL}/${data.web_store}`,
			};
		},
	},
	methods: {
		// toggle full screen method
		toggleFullScreen() {
			if (screenfull.enabled) {
				screenfull.toggle();
			}
		},
		sidebarPath(link) {
			this.$store.dispatch("setActiveMenuGroup", { pathURL: link });
			this.$router.push(this.getMenuLink(link));
		},
		getMenuLink(link) {
			return "/" + getCurrentAppLayout(this.$router) + link;
		},
		toggleSearchForm() {
			this.$store.dispatch("toggleSearchForm");
		},
		sendBroadcast() {
			this.showSendMessage = true;
		},
	},
	components: {
		appSidebar: Sidebar,
		ChatSidebar,
		LanguageProvider,
		Notifications,
		Cart,
		QuickLinks,
		MobileSearchForm,
		User,
		BroadcastMessage,
	},
};
</script>
<style lang="scss" scoped>
.navbar-left {
	width: 100%;
}
.header-toolbar {
	background-color: #262261 !important;
	* {
		color: #c9e2ff !important;
	}
}
.store-icons-container {
	flex-grow: 1;
	display: flex;
	justify-content: flex-end;
}
</style>
